export default "__VITE_ASSET__DDqll79m__"